import { convertArrayToObject } from '@/helpers/utils'

export default {
  backendHostname: (state) => state.backendHostname,
  admLevels: (state) => state.admLevels,
  emitterCategorytypes: (state) => state.emitterCategorytypes,
  admLevelsMap: (state) => {
    const byId = {}
    state.admLevels.forEach((v) => {
      byId[v.adm_level] = v.name || 'Уровень ' + v.adm_level
    })
    return byId
  },
  emitterCategorytypesMap: (state) => convertArrayToObject(state.emitterCategorytypes, 'id'),
  endpoint: (state) => state.endpoint,
  apiError: (state) => state.apiError,
  settings: (state) => state.settings,
  defaultSettings: (state) => state.defaultSettings,
  periods: (state) => state.periods,
  seasons: (state) => state.seasons,
  years: (state) => state.years,
  colors: (state) => state.colors,
  colorsArray: (state) => {
    return Object.keys(state.colors).reduce((accumulator, current) => {
      accumulator.push(state.colors[current])
      return accumulator
    }, [])
  },
  zones: (state) => state.zones,
  zoneGroups: (state) => state.zoneGroups,
  admTerritories: (state) => state.admTerritories,
  separatedTerritories: (state) => state.separatedTerritories,
  helperType: (state) => state.helperType,
  theme: (state) => state.theme,
  convertfunctions: (state) => state.convertfunctions,
  economicModels: (state) => state.economicModels,
  apiVersion: (state) => state.apiVersion,
  yandexApiKey: (state) => state.yandexApiKey,
  isInitLoading: (state) => state.isInitLoading,
  treatments: (state) => state.treatments,
  logo: (state) => state.logo,
  treatmentsMap: (state) => {
    const map = {}
    state.treatments.forEach((v) => {
      map[v.id] = { ...v }
    })
    return map
  },

  currentWs: (state, getters) => {
    return getters.workspace && getters.activeWorkspaceList
      ? getters.activeWorkspaceList.filter((v) => {
          return v.id === getters.workspace
        })
      : null
  },

  isPublicWs: (state, getters) => {
    return getters.currentWs && getters.currentWs[0] ? getters.currentWs[0].public : false
  },

  itemsWithColors: (state, getters) => {
    return state.items.map((item) => {
      return {
        ...item,
        color: getters.colors[item.color].hex
      }
    })
  },

  treatmentsWithColors: (state, getters) => {
    return getters.treatments.map((treatment) => {
      return {
        ...treatment,
        color: getters.colors[treatment.color].hex
      }
    })
  },

  terschemaListCount: (state) => {
    return state.terschemaListCount
  },

  controlListCount: (state) => {
    return state.controlListCount
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js